import React, { forwardRef, ReactElement, useEffect, useState } from 'react';
import { InputBase } from 'component-library/index';
import { regexValidation } from '../../../../utils/cob-utils';
import InputBaseOrangeAsteriskVariant from '../../../../component-library/atoms/InputBase/Variants/OrangeAsteriskVariant/InputBaseOrangeAsteriskVariant';

export interface ICityProps {
    addressType?: string;
    className?: string;
    inputClass?: string;
    id?: string;
    errorText?: string;
    label?:  string | ReactElement | ReactElement[];
    error?: boolean;
    required?: boolean;
    requiredMessage?: string;
    alternate?: boolean;
    maxLength?: number;
    invalidErrorMessage?: string;
    valid?: [boolean, (arg?: any) => void];
    value?: string;
    useSuccessIcon?: boolean;
    showSuccessIcon?: boolean;
    useOutsideValidation?: boolean;
    setValueCallback: THandlerFunction;
    onBlurCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onFocusCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onKeyDownCallback?: React.KeyboardEventHandler<HTMLElement>;
    disabled?: boolean;
    isPrefill?: boolean;
    orangeAsterisksOnMobile?: boolean;
}

const CityField = (({    
    value = '',
    className,
    setValueCallback,
    onBlurCallback,
    onFocusCallback,
    onKeyDownCallback,
    useSuccessIcon,
    showSuccessIcon,
    useOutsideValidation,
    valid,
    error,
    isPrefill,
    orangeAsterisksOnMobile,
    ...rest 
}: ICityProps, ref) => {
    const [showIcon, setShowIcon] = useState(false);
    const [isFieldValid, setIsFieldValid] = useState(false);
    const [isBlurred, setIsBlurred] = useState(false);
    const regex = regexValidation();
    const validity = valid ?? [isFieldValid, setIsFieldValid];

    const validateField = () => {
        value = value ? value.trim(): '';
        if (value === '') {
            return false;
        }
        return value &&
        regex.city.test(value);
    };

    const focusHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.type === 'blur') {
            onBlurCallback && onBlurCallback(e);
        } else if (e.type === 'focus') {
            onFocusCallback && onFocusCallback(e);
        }
        setIsBlurred(e.type !== 'focus');
        handleSuccessIcon(e.type === 'focus');
    };

    const formatValue = (value) => {
        if (value.length > 30) {
            value = value.substring(0, 30);
        }
        return value;
    };

    const handleSetValue = (e) => {
        
        if (!validity[0]) {
            validity[1](true);
        }
        setValueCallback && setValueCallback(formatValue(e));
    };

    const handleSuccessIcon = (isActive: boolean = false) => {
        const isShowIcon = (useOutsideValidation ?? true) && validateField() && !isActive;
        setShowIcon(isShowIcon);
    };

    useEffect(() => {
        setIsBlurred(true);
    }, []);

    useEffect(() => {
        if (useOutsideValidation === undefined || !isBlurred) {
            return;
        }

        handleSuccessIcon();
    }, [value, useOutsideValidation]);

    useEffect(() => {
        if (isPrefill) {
            setShowIcon(false);
        }
    }, [isPrefill]);
    
    return (
        <div className={`CityField ${className ?? ''}`}>
            {!orangeAsterisksOnMobile && 
            <InputBase
                {...rest}
                ref={ref}
                value={value}
                setValue={handleSetValue}
                onBlur={focusHandler}
                onFocus={focusHandler}
                onKeyDown={onKeyDownCallback}
                isValid={validateField}
                valid={validity}
                error={error}
                useSuccessIcon={useSuccessIcon}
                showSuccessIcon={showSuccessIcon !== undefined ? showSuccessIcon : showIcon}
                showExclamationError
            />}
            {orangeAsterisksOnMobile && 
                <InputBaseOrangeAsteriskVariant
                    {...rest}
                    ref={ref}
                    value={value}
                    setValue={handleSetValue}
                    onBlur={focusHandler}
                    onFocus={focusHandler}
                    onKeyDown={onKeyDownCallback}
                    isValid={validateField}
                    valid={validity}
                    error={error}
                    useSuccessIcon={useSuccessIcon}
                    showSuccessIcon={showSuccessIcon !== undefined ? showSuccessIcon : showIcon}
                    showExclamationError
                />
            }
        </div>
    );
});

export default forwardRef(CityField);